import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Creatable from './inputs/creatable';
import Util from '../forecast-app/shared/util/util';

class LabelsDropdown extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isFocused: false,
		};
	}

	removeLabel(labelId) {
		const values = this.props.value
			.filter(value => {
				return value !== labelId;
			})
			.map(value => {
				return {value: value};
			});
		this.props.onChange(values);
	}

	handleFocus() {
		this.setState({isFocused: true});
	}

	handleBlur() {
		this.setState({isFocused: false});
		if (this.props.onBlur && !this.props.disabled) {
			this.props.onBlur();
		}
	}

	onNewOptionClick(label) {
		if (!this.props.disableLabelCreation) {
			this.props.createNewLabel(label);
		}
	}

	render() {
		const options = this.props.getOptions ? this.props.getOptions() : this.props.options;
		const chips = options.filter(option => {
			return this.props.value.includes(option.value);
		});
		const creatable = (
			<Creatable
				optionCy={this.props.optionCy}
				dataCy={this.props.cy}
				disableLabelCreation={this.props.disableLabelCreation}
				options={options}
				value={this.props.value}
				locked={this.props.disabled}
				label={this.props.placeholder}
				translationId="labels_dropdown.create-new"
				onNewOptionClick={this.onNewOptionClick.bind(this)}
				removeSelected={this.removeLabel.bind(this)}
				onChange={this.props.onChange}
				placeholder={this.props.helpText}
			/>
		);
		const labelsDropdownChips = (
			<div className="labels-dropdown-chips">
				{chips.map((chip, index) => (
					<div data-cy="label-chip" className="chip" key={'label-dropdown-chip-' + index} style={{backgroundColor: chip.color, color: Util.getTextColor(chip.color)}}>
						<div className="text" data-cy="label-chip-name">
							<div>{'#' + chip.label}</div>
						</div>
						<div data-cy="label-chip-delete" className="delete" onClick={this.removeLabel.bind(this, chip.value)} />
					</div>
				))}
			</div>
		);
		return (
			<div className="labels-dropdown" onBlur={this.handleBlur.bind(this)} tabIndex="0" ref={labelsDropdown => (this.labelsDropdown = labelsDropdown)}>
				{this.props.showLabelsOnTop ? labelsDropdownChips : creatable}
				{this.props.showLabelsOnTop ? creatable : labelsDropdownChips}
			</div>
		);
	}
}

LabelsDropdown.propTypes = {
	options: PropTypes.array,
	onChange: PropTypes.func,
	value: PropTypes.array,
	placeholder: PropTypes.string,
	createNewLabel: PropTypes.func.isRequired,
	helpText: PropTypes.string,
	showLabelsOnTop: PropTypes.bool,
};

export default LabelsDropdown;
